import { render, staticRenderFns } from "./CTableHead.vue?vue&type=template&id=443b0750&scoped=true&"
import script from "./CTableHead.vue?vue&type=script&lang=ts&"
export * from "./CTableHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b0750",
  null
  
)

export default component.exports